var React = require('react');

function CloseCircleInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M10 19.0001C14.9706 19.0001 19 14.9707 19 10.0001C19 5.02947 14.9706 1 10 1C5.02944 1 1 5.02947 1 10.0001C1 14.9707 5.02944 19.0001 10 19.0001Z","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8.23218 8.23291L11.7679 11.7678","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8.23212 11.7678L11.7678 8.23291","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]));
}

CloseCircleInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CloseCircleInline;

CloseCircleInline.default = CloseCircleInline;
